import { useEffect, useState } from "react";
import { FaTachometerAlt, FaInbox, FaUsers, FaSignOutAlt, FaBars, FaUser } from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { IoSettings } from "react-icons/io5";
import { auth } from "./Firebase";
import { AiOutlineProduct } from "react-icons/ai";
import { MdOutlineCategory, MdOutlineProductionQuantityLimits } from "react-icons/md";

export default function Sidebar({ children }) {
    const location = useLocation();
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);

    const menuItems = [
        { link: "/Dashboard", label: "Dashboard", icon: <FaTachometerAlt /> },
        { link: "/Enquiries", label: "Enquiries", icon: <FaInbox /> },
        { link: "/Distributorship", label: "Distributorship", icon: <FaUsers /> },
        { link: "/Users", label: "User Management", icon: <FaUser /> },
        { link: "/Settings", label: "Settings", icon: <IoSettings /> },
    ];

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (!user) {
                navigate("/login");
            }
        });

        return () => unsubscribe();
    }, [navigate]);

    function logout() {
        auth.signOut().then(() => navigate("/login"));
    }


    return (
        <div className="d-flex">
            <div className={`bg-light vh-100 shadow position-fixed top-0 start-0 d-flex flex-column 
                ${isCollapsed ? "collapsed" : ""} 
                ${isSidebarOpen ? "mobile-open" : ""}`}
                style={{
                    width: isCollapsed ? "65px" : "250px", transition: "width 0.3s ease-in-out", zIndex: 1050
                }}>
                <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
                    {!isCollapsed && <h5 className="m-0">Admin Panel</h5>}
                    <button className="btn btn-sm btn-outline-secondary d-md-block" onClick={() => setIsCollapsed(!isCollapsed)}>
                        {isCollapsed ? ">>" : "<<"}
                    </button>
                </div>
                <ul className="list-unstyled flex-grow-1 m-0 p-1">
                    {menuItems.map((item) => (
                        <li key={item.link} className={`p-2 d-flex align-items-center sidebar-item 
                            ${location.pathname === item.link ? "bg-primary text-light rounded" : ""}`}>
                            <Link to={item.link} className={"d-flex align-items-center text-decoration-none text-dark w-100 " + (isCollapsed ? "justify-content-center" : "")} onClick={() => setIsSidebarOpen(false)}>
                                <span className={"me-2 " + (isCollapsed ? "ms-2" : "")}>{item.icon}</span>
                                {!isCollapsed && <span>{item.label}</span>}
                            </Link>
                        </li>
                    ))}

                </ul>

                <div className={`p-2 d-flex align-items-center sidebar-item ${isCollapsed ? "justify-content-center" : ""}`} onClick={logout} style={{ cursor: "pointer" }}>
                    <FaSignOutAlt className="ms-1" size={18} />
                    {!isCollapsed && <span className="ms-2">Logout</span>}
                </div>
            </div>

            <div className="flex-grow-1" style={{
                marginLeft: isCollapsed ? "65px" : "250px",
                transition: "margin 0.3s ease-in-out"
            }}>
                <nav className="navbar navbar-light bg-light shadow-sm sticky-top">
                    <div className="container-fluid d-flex justify-content-end align-items-center">
                        <div className="d-flex align-items-center">
                            <button className="rounded-circle btn btn-primary text-light me-2">A</button>
                            <p className="m-0">Admin user</p>
                        </div>
                    </div>
                </nav>
                <div className="p-4">{children}</div>
            </div>

            <style>{`
        /* Hide sidebar on mobile */
        @media (max-width: 768px) {
          .sidebar {
            transform: translateX(-100%);
          }
          .mobile-open {
            transform: translateX(0);
            width: 250px;
            position: fixed;
          }
        }
      `}
            </style>
        </div>
    );
}
